import { makeStyles, createStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() =>
  createStyles({
    button: {
      lineHeight: '18px',
    },
  })
);
